var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChannels(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "22px",
    viewBox: "0 0 21 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Channels") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DataGate-LP---Action-Buttons",
    transform: "translate(-602.000000, -360.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Channels",
    transform: "translate(602.000000, 360.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,10 C14,11.656 12.656,13 11,13 C9.343,13 8,11.656 8,10 C8,8.344 9.343,7 11,7 C12.656,7 14,8.344 14,10",
    id: "Fill-628"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.707,4.293 C13.318,4.682 13.318,5.318 13.707,5.707 L15.293,7.293 C15.682,7.682 16.318,7.682 16.707,7.293 L20.293,3.707 C20.682,3.318 20.682,2.682 20.293,2.293 L18.707,0.707 C18.318,0.318 17.682,0.318 17.293,0.707 L13.707,4.293 Z",
    id: "Fill-629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.293,4.293 C8.682,4.682 8.682,5.318 8.293,5.707 L5.707,8.293 C5.318,8.682 4.682,8.682 4.293,8.293 L3.707,7.707 C3.318,7.318 3.318,6.682 3.707,6.293 L6.293,3.707 C6.682,3.318 7.318,3.318 7.707,3.707 L8.293,4.293 Z",
    id: "Fill-630"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.293,1.293 C5.682,1.682 5.682,2.318 5.293,2.707 L2.707,5.293 C2.318,5.682 1.682,5.682 1.293,5.293 L0.707,4.707 C0.318,4.318 0.318,3.682 0.707,3.293 L3.293,0.707 C3.682,0.318 4.318,0.318 4.707,0.707 L5.293,1.293 Z",
    id: "Fill-631"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,20 C14,20.55 13.55,21 13,21 L9,21 C8.45,21 8,20.55 8,20 L8,19 C8,18.45 8.45,18 9,18 L13,18 C13.55,18 14,18.45 14,19 L14,20 Z",
    id: "Fill-632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,16 C14,16.55 13.55,17 13,17 L9,17 C8.45,17 8,16.55 8,16 L8,15 C8,14.45 8.45,14 9,14 L13,14 C13.55,14 14,14.45 14,15 L14,16 Z",
    id: "Fill-633"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannels);
export default __webpack_public_path__ + "static/media/channels.2f52818543cd5a5a48b7269b5f10a242.svg";
export { ForwardRef as ReactComponent };